/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */
var combineFunctions = function combineFunctions(a, b) {
  return function (v) {
    return b(a(v));
  };
};
var pipe = function pipe() {
  for (var _len = arguments.length, transformers = new Array(_len), _key = 0; _key < _len; _key++) {
    transformers[_key] = arguments[_key];
  }
  return transformers.reduce(combineFunctions);
};
export { pipe };